export function useAction(node: HTMLElement | Element, action: () => void) {
	node.addEventListener('click', action)

	return {
		destroy() {
			node.removeEventListener('click', action)
		}
	}
}
